import { Dispatch, SetStateAction, useState } from "react";
import { Form, Modal } from "rsuite";
import { ApiFinance } from "../../core/apis";
import { useAppDispatch } from "../../core/redux";
import { UtilityDate } from "../../utils";
import { DateInput, TextAreaInput, TextInput } from "../textInput.component";
import { ModalGeneric } from "./ModalGeneric";

interface IProps<A> {
  invoiceSKey: string;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  paymentFor: "patient" | "caregiver";
  Action: A;
}

interface IReduxAction {
  payload: boolean;
  type: string;
}

interface IReduxActions {
  setIsLoading: (payload: boolean) => IReduxAction;
  setRefetch: (payload: boolean) => IReduxAction;
}

export function ModalPaymentInformation<A extends IReduxActions>({
  invoiceSKey,
  show,
  paymentFor,
  setShow,
  Action,
}: IProps<A>) {
  const dispatch = useAppDispatch();
  const [paymentDate, setPaymentDate] = useState<Date>();
  const [checkNumber, setCheckNumber] = useState("");
  const [paymentNote, setPaymentNote] = useState("");

  const toggleModal = () => {
    setShow(!show);
  };
  const handleSubmit = async () => {
    if (!paymentNote || !paymentDate) {
      return;
    }
    toggleModal();
    dispatch(Action.setIsLoading(true));
    let ApiCall;
    if (paymentFor === "caregiver") {
      ApiCall = ApiFinance.MarkAsPaidCaregiver;
    } else {
      ApiCall = ApiFinance.MarkAsPaidPatient;
    }
    const response = await ApiCall({
      Date: UtilityDate.getDateOnly(paymentDate?.toISOString()).toISOString(),
      Note: paymentNote,
      CheckNumber: checkNumber,
      InvoiceSKey: invoiceSKey,
    });
    if (response.isSuccess) {
      dispatch(Action.setRefetch(true));
    }
    dispatch(Action.setIsLoading(false));
  };

  return (
    <ModalGeneric
      open={show}
      header={{
        element: (
          <Modal.Title>
            <b>Payment Information</b>
          </Modal.Title>
        ),
      }}
      footer={{ submitBtnText: "Mark as paid", onSubmit: handleSubmit }}
      onClose={toggleModal}
    >
      <Form>
        <TextInput
          name="CheckNumber"
          wrapperClass="fullwidth-input-wrapper"
          onChange={(value) => setCheckNumber(value)}
          required
        >
          Check / Invoice number
        </TextInput>
        <DateInput
          name="Date"
          wrapperClass="fullwidth-input-wrapper"
          onChange={(value) => setPaymentDate(value)}
          required
        >
          Paid on
        </DateInput>
        <TextAreaInput
          name="Note"
          wrapperClass="fullwidth-input-wrapper"
          onChange={(value) => setPaymentNote(value)}
        >
          Note
        </TextAreaInput>
      </Form>
    </ModalGeneric>
  );
}
